import { render, staticRenderFns } from "./CheckboxRecaptcha.vue?vue&type=template&id=368eb563&"
import script from "./CheckboxRecaptcha.vue?vue&type=script&lang=ts&"
export * from "./CheckboxRecaptcha.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports